import { useQuery } from 'react-query';

import { QUERY_KEYS } from '../constants';
import { fetchVersions } from '../request';

export const useGetVersions = (enabled = true) => {
  const { isLoading, data, error } = useQuery({
    queryKey: [QUERY_KEYS.GET_VERSIONS],
    queryFn: fetchVersions,
    cacheTime: 0,
    enabled,
  });

  return { data, isLoading, error };
};
